module.exports = __webpack_public_path__ + "static/media/Countdown - Clock Only.d27402a0.mp3";